export type AssertiveYieldPageViewType = 'initial' | 'navigation'

/**
 * Keeps AY pageview boundaries aligned with accepted NtpPage_Viewed events.
 * AY creates the initial pageview when its manager starts, so only navigation
 * events need an explicit page change.
 */
export function syncAssertiveYieldPageView(
  type: AssertiveYieldPageViewType
): void {
  if (!import.meta.client) return
  if (type === 'initial') return

  const manager = window.ayManagerEnv
  manager?.cmd.push(() => {
    manager.changePage()
  })
}
